import {BackButton, Rules} from "@/components";
import {StickyHeader} from "@chayka/ui";

export const RulesPage = () => {
  return (
    <>
      <StickyHeader title="Правила студии" leftPart={<BackButton />} />
      <Rules />
    </>
  );
};
